export default __webpack_public_path__ + "static/rollup@2x-622ed94c354df85ac8ad2f0997c8b942.jpg";